import { MiniMatchTileController } from "./mini-match-tile.controller";
import "./mini-match-tile.style.scss";

const miniMatchTileDirective = function(): Record<string, any> {
	return {
		restrict: "E",
		template: require("./mini-match-tile.template.html"),
		controller: MiniMatchTileController,
		controllerAs: "mtc",
	};
};

export default miniMatchTileDirective;